<!--header-->
<div class="header">
  <!-- Logo -->
  <div class="header-left d-xl-none d-lg-none">
    <a [routerLink]="['/dashboard']" class="logo">
      <img src="assets/img/logo.png" width="110" height="35" alt="" />
    </a>
  </div>

  <!-- /Logo -->
  <a
    id="toggle_btn"
    (click)="toggleSidebar()"
    href="javascript:void(0);"
  >
    <span class="bar-icon">
      <span></span>
      <span></span>
      <span></span>
    </span>
  </a>
  <!-- Header Title -->
  <div class="page-title-box d-lg-block cus-title1">
    <a [routerLink]="['/dashboard']" class="logo pt-2">
      <img src="assets/image/mobiliselogo.png" width="120" alt="" />
    </a>
  </div>

  <!-- /Header Title -->
  <!-- Header Menu -->
  <ul class="nav user-menu">
  </ul>
</div>
<!--/header-->

<div class="page-wrapper" style="min-height: 347px">
    <div class="col col-xs-12">
        <div class="padding-main-side table-filter2">
           <div class="container">
            <div class="row">
                    <div class="col-12">
                        <form (ngSubmit)="searchJobs()" [formGroup]="searchJobForm">
                            <div class="main_font">
                            <h2>Find your dream job now</h2>
                            <p class="mb-2"><span class="font_size">1 Thousand + jobs for you to explore</span></p>
                            <div class="qsb">
                                <img src="//static.naukimg.com/s/7/103/i/search.57b43584.svg" alt="" class="searchIcon">
                                <div class="keywordSugg">
                                <div>
                                    <div class="suggestor-wrapper active " style="position: relative;">
                                        <div style="position: relative; overflow: hidden; height: auto; min-height: 0px; max-height: 500px;">
                                            <div style="position: relative; overflow: auto scroll; margin-right: -17px; margin-bottom: 0px; min-height: 17px; max-height: 500px;">
                                            <div class="suggestor-box flex-row flex-wrap bottom "><input class="suggestor-input " type="text" formControlName="design" placeholder="Enter designations" tabindex="0" value=""></div>
                                            </div>
                                            <div class="track-horizontal" style="display: none; visibility: hidden;">
                                            <div class="track-horizontal" style="display: none; width: 0px;"></div>
                                            </div>
                                            <div class="verticalTrack" style="position: absolute; width: 6px; right: 2px; bottom: 2px; top: 2px; border-radius: 6px; background-color: rgb(226, 226, 226); visibility: hidden;">
                                            <div class="verticalThumb" style="position: relative; display: block; width: 100%; background-color: rgb(179, 179, 179); border-radius: 6px; height: 0px;"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                <div class="pipe"></div>
                                <div class="qsbExperience">
                                <div class="dropdownMainContainer" style="border:none">                            
                                    <select formControlName="region" class="form-control custom-select">
                                        <option value="">All Region</option>
                                        <option value={{rgn.value}} *ngFor="let rgn of regionAll">{{rgn.label}}</option>
                                    </select>
                                </div>
                                </div>
                                <div class="pipe"></div>
                                <div class="qsbExperience">
                                <div class="dropdownMainContainer" style="border:none">                            
                                    <select formControlName="state" class="form-control custom-select" (change)="getStateCity($event)">
                                        <option value="" selected>Select State</option>
                                        <option value="{{item.st_id}}" *ngFor = "let item of stateList">{{item.st_name}}</option>
                                    </select>
                                </div>
                                </div>

                                <div class="pipe"></div>
                                <div class="qsbExperience">
                                <div class="dropdownMainContainer" style="border:none">                            
                                    <select formControlName="city" class="form-control custom-select " placeholder="Select City...">
                                        <option value="" selected>Select City</option>
                                        <option value="{{item.ct_id}}" *ngFor="let item of cityList">{{item.ct_name}}</option>
                                    </select>
                                </div>
                                </div>

                                <div class="pipe"></div>
                                <div class="qsbExperience">
                                <div class="dropdownMainContainer" style="border:none">                            
                                    <select formControlName="job_type" class="form-control custom-select ">
                                        <option value="" selected>Select Jobs</option>
                                        <option value="1">FTC</option>
                                        <option value="2">Regular</option>
                                    </select>
                                </div>
                                </div>

                                <button class="qsbSubmit">Search</button>
                            </div>
                            </div>
                            <div id="trending-naukri-wdgt">
                                <div class="naukri-trending-container mt-4 mb-4">
                                   
                                <div class="ntc__chips-row">

                                    <p class="ntc__chip-wrapper" href="#" title="Most View">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="Most View" (click)="latestJob('hotJob')">Host Jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>



                                    <p class="ntc__chip-wrapper" href="#" title="Most View">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="Most View" (click)="latestJob('View')"> Most View</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="Female jobs">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="Female jobs" (click)="latestJob('2')"> Female jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="NCR Jobs">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="NCR Jobs" (click)="latestJob('3')"> NCR Jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="ANDHRA PRADESH Jobs">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="ANDHRA PRADESH Jobs" (click)="latestJob('6')"> ANDHRA PRADESH Jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="KARNATAKA Jobs">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="KARNATAKA Jobs" (click)="latestJob('4')"> KARNATAKA Jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>
                                    
                                </div>
                                <div class="ntc__chips-row">
                                    <p class="ntc__chip-wrapper" href="#" title="KOLKATA Jobs">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="KOLKATA Jobs" (click)="latestJob('8')"> KOLKATA Jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="GUJARAT Jobs">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="GUJARAT Jobs" (click)="latestJob('7')"> GUJARAT Jobs</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="MUMBAI">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="MUMBAI" (click)="latestJob('1')"> MUMBAI</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="TAMIL NADU">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="TAMIL NADU" (click)="latestJob('5')"> TAMIL NADU</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>

                                    <p class="ntc__chip-wrapper" href="#" title="GOA JOBS">
                                        <img src="assets/img/question.svg" class ="icon-main ng-tns-c248-0 ml-2">
                                        <span class="ntc__chip-label" title="GOA JOBS" (click)="latestJob('10')"> GOA JOBS</span>
                                        <img class="ntc__chip-arrow" src="assets/img/arrow.2b55815e.svg" alt="arrow-icon"></p>
                                </div>
                                </div>
                            </div>
                        </form>
                    </div>
                <div class="col-3">
                    <div class="sec_1">
                         <div class="border-bottom mb-2">
                            <h3 class="m-0 font-weight-bold">Job Search</h3>
                         </div>
                            <div class="row border-bottom"  *ngFor="let jobsCat of jobsCategory ;let i = index;">
                                <div class="col-md-12 mb-2">
                                    <input type="checkbox" id="vehicle1" [(ngModel)]="jobsCat.isCheck" (change)="jobCat()">
                                    <label for="vehicle1" class="texts"> {{jobsCat.option_desc}}</label>
                                </div>
                            </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="sec_1 mb-4" *ngFor="let list of ijpListFTC ;let i = index;">
                        <div class="row">
                            <div class="col-10">
                                <div class="job_h">
                                    <h2 class="font-weight-bold">{{list.desig_desc}}</h2>
                                    <!-- <div class="">
                                        <p>{{list.ijp_code}} <span class="color_s"><i class="fa fa-star"></i> 4.1 |1362 Reviews</span></p>
                                    </div> -->
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="job_img">
                                    <img src="assets/img/logo.png">
                                </div>
                            </div>
                            <div class="col-12">
                                <p><span class="color_s color_s2"><i class="fa fa-map-marker"></i> {{list.cost_center}} , {{list.ct_name}} , {{list.st_name}}</span></p>
                                <p><i class="fa fa-calendar"></i> Experience :<span class="text-blue"> {{list.exp_frm}} - {{list.exp_to}} years </span></p>
                                <ul class="job-post-det color_s2">
                                    <!-- <li>
                                        <i class="fa fa-calendar"></i> Experience: <span class="text-blue">{{list.exp_frm}} - {{list.exp_to}} years </span>
                                    </li> -->

                                    <li>
                                        <i class="fa fa-calendar"></i> Posted Date: <span class="text-blue">{{list.created_at}}</span>
                                    </li>
                                    <li>
                                        <i class="fa fa-users m-r-5"></i> Total Applications: <span class="text-blue">{{list.applicants}}</span>
                                    </li>
                                    <li class="rdx">
                                        <i class="fa fa-eye m-r-5"></i> Views: <span class="text-blue">{{list.views}}</span>
                                    </li>
                                    <li class="rdxg">
                                        <span class="btn_Section">
                                            <button type="button" class="login-apply-button loginBtn" [routerLink]="['/jobdetails/'+list.mrf_id]">Apply Now</button>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="sec_1">
                         <div class="border-bottom mb-2">
                            <h3 class="m-0 font-weight-bold">More Job's</h3>
                         </div>
                        <div class="row ">
                            <div class="col-12">
                                <div class="heading_s border-bottom mt-2" *ngFor="let listJobs of ijpListMoreFTC ;let i = index;">
                                    <h4 class="m-0">{{listJobs.desig_desc}}</h4>
                                    <div class="">
                                        <!-- <p>Shahi <span class="color_s"><i class="fa fa-star"></i> 4.1 |1362 Reviews</span></p> -->
                                    </div>
                                        <p><span class="color_s"><i class="fa fa-map-marker"></i> {{listJobs.cost_center}} , {{listJobs.ct_name}} , {{listJobs.st_name}}</span></p>
                                        <ul class="job-post-det">
                                            <li>
                                                <i class="fa fa-calendar"></i> Posted Date: <span class="text-blue">{{listJobs.created_at}}</span>
                                            </li>
                                            <li>
                                                <i class="fa fa-users m-r-5"></i> Total Applications: <span class="text-blue">{{listJobs.applicants}}</span>
                                            </li>
                                            <li>
                                                <i class="fa fa-eye m-r-5"></i> Views: <span class="text-blue">{{listJobs.views}}</span>
                                            </li>
                                        </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
           </div>


           
           <!-- Fotter Start -->
           <div class="Foot_sec mt-3 pt-3">
            <div class="row">
                <div class="col-2">
                    <div class="fot_sec">
                        <div class="img_fotter">
                            <img src="assets/image/mobiliselogo.png">
                        </div>
                        <div class="social_icn mt-4">
                            <p class="font-weight-bold">Connect with us</p>
                            <ul class="d_flex Social_i">
                                <li>
                                    <i class="fa fa-facebook-f"></i>
                                </li>
                                <li>
                                    <a href="#" target="_blank">
                                    <i class="fa fa-instagram"></i></a>
                                </li>
                                <li>

                                    <a href="https://twitter.com/i/flow/login" target="_blank">
                                    <i class="fa fa-twitter"></i></a>
                                </li>
                                <li>
                                    <a href="#" target="_blank"><i class="fa fa-linkedin"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-10">
                    <div class="ImageSec">
                        <img src="assets/img/sdx2.jpg">
                    </div>
                </div>
            </div>
       </div>
       <!-- Fotter End -->
           <!-- Fotter End -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->